import moment from 'moment'

const helper = {
  /* hibc */
  getYearForHibc(date = '', start = '01-01') {
    return `${`${new Date().getFullYear()}`.substring(0, 2)}${date.substring(0, 2)}${start.padStart(
      6,
      '-'
    )}`
  },
  getDayForHibc(date = '') {
    return ((+`${date.substring(2, 5)}` || 1) - 1) * 24 * 60 * 60 * 1000
  },
  getHourForHibc(date = '') {
    return (+`${date.substring(5, 7)}` || 0) * 60 * 60 * 1000
  },
  getFormatDateForHibc(date = '', format = 'YYYY-MM-DD') {
    const year = helper.getYearForHibc(date)
    const day = helper.getDayForHibc(date)
    const hour = helper.getHourForHibc(date)
    const timestamp = moment(year).valueOf() + day + hour

    return moment(timestamp).format(format)
  },
}

const dateUtils = {}
// 格式化日期: Ma
dateUtils.formatMaDate = function (date) {
  const year = `${new Date().getFullYear()}`.substring(0, 2) // 年份头2位 eg. 2021 -> 20
  return `${year}${date.replace(/(\d{2})(?!$)/g, '$1-')}`
}
// 格式化日期: HIBC
dateUtils.formatHibcDate = function (date, format = 'YYYY-MM-DD', separate = '-') {
  const year = `${new Date().getFullYear()}`.substring(0, 2)
  if (format === 'YYYY-MM-DD')
    return date.replace(/(^\d{4})(\d{2})(\d{2}$)/, `$1${separate}$2${separate}$3`)
  if (format === 'YY-MM-DD')
    return date.replace(/(^\d{2})(\d{2})(\d{2}$)/, `${year}$1${separate}$2${separate}$3`)
  if (format === 'YYMMDDHH') {
    const formatDate = `${year}${date.replace(/(\d{2})(?!$)/g, `$1${separate}`)}:00:00`
    const pos = formatDate.lastIndexOf('/')

    return formatDate.substring(0, pos) + ' ' + formatDate.substring(pos + 1)
  }
  if (format === 'YYJJJ') {
    return helper.getFormatDateForHibc(date, `YYYY${separate}MM${separate}DD`)
  }
  if (format === 'YYJJJHH') {
    return helper.getFormatDateForHibc(date, `YYYY${separate}MM${separate}DD HH:mm:ss`)
  }
  if (format === 'MMYY' || format === 'MMDDYY') {
    if (format === 'MMYY') {
      date = date.replace(/(\d{2})(\d{2})/, '$2$1')
    }
    if (format === 'MMDDYY') {
      date = date.replace(/(\d{4})(\d{2})/, '$2$1')
    }
    return `${year}${date.replace(/(\d{2})(?!$)/g, `$1${separate}`)}`
  }

  return `${year}${date.replace(/(\d{2})(?!$)/g, `$1${separate}`)}`
}

export default dateUtils
